module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.eaf9b428.svg";